interface CognitoErrorLike {
  code?: unknown;
  name?: unknown;
  message?: unknown;
}

function asCognitoErrorLike(error: unknown): CognitoErrorLike | null {
  if (!error || typeof error !== 'object') return null;
  return error as CognitoErrorLike;
}

/**
 * Cognito can surface duplicate-email signup failures through different fields
 * depending on library/runtime. Centralize detection so auth surfaces stay
 * consistent across web and native.
 */
export function isUsernameExistsError(error: unknown): boolean {
  const cognitoError = asCognitoErrorLike(error);
  if (!cognitoError) return false;

  const code = typeof cognitoError.code === 'string' ? cognitoError.code : '';
  const name = typeof cognitoError.name === 'string' ? cognitoError.name : '';
  const message = typeof cognitoError.message === 'string' ? cognitoError.message : '';

  return (
    code === 'UsernameExistsException' ||
    name === 'UsernameExistsException' ||
    message.includes('UsernameExistsException') ||
    message.toLowerCase().includes('user already exists')
  );
}

export function isInvalidCredentialsError(error: unknown): boolean {
  const cognitoError = asCognitoErrorLike(error);
  if (!cognitoError) return false;

  const code = typeof cognitoError.code === 'string' ? cognitoError.code : '';
  const name = typeof cognitoError.name === 'string' ? cognitoError.name : '';
  const message = typeof cognitoError.message === 'string' ? cognitoError.message : '';
  const lowercaseMessage = message.toLowerCase();

  return (
    code === 'NotAuthorizedException' ||
    code === 'UserNotFoundException' ||
    name === 'NotAuthorizedException' ||
    name === 'UserNotFoundException' ||
    lowercaseMessage.includes('incorrect username or password') ||
    lowercaseMessage.includes('incorrect') ||
    lowercaseMessage.includes('invalid credentials')
  );
}

export const USERNAME_EXISTS_ALERT_TITLE = 'Account already exists';
export const USERNAME_EXISTS_ALERT_MESSAGE =
  'An account with this email already exists. Log in instead, or use Forgot password if needed.';

export const INVALID_CREDENTIALS_ALERT_TITLE = 'Login failed';
export const INVALID_CREDENTIALS_ALERT_MESSAGE =
  'Email or password is incorrect. Please try again.';

export const ACCOUNT_SYNC_ALERT_TITLE = 'Account error';
export const ACCOUNT_SYNC_ALERT_MESSAGE =
  'We could not load your account data. Please try again.';
